import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-dmdprecpte',
  templateUrl: './dmdprecpte.component.html',
  styleUrls: ['./dmdprecpte.component.scss']
})
export class DmdprecpteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
